import { CUSTOM_DOCUMENT_SYSTEM_TYPE } from './documentDisplayName';

export type DocumentSearchFields = {
  typeLabel?: string | null;
  fileName?: string | null;
  customDocumentName?: string | null;
  comment?: string | null;
  documentType?: string | null;
};

/** Client-side search for registry rows, pickers, and application document lists. */
export function documentMatchesSearchQuery(fields: DocumentSearchFields, query: string): boolean {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return true;

  const docType = String(fields.documentType || '').trim().toUpperCase();
  const avoidGenericOtherLabel =
    docType === CUSTOM_DOCUMENT_SYSTEM_TYPE &&
    String(fields.typeLabel || '').trim().toLowerCase() === 'другое';

  const parts = [
    fields.fileName,
    fields.customDocumentName,
    fields.comment,
    avoidGenericOtherLabel ? null : fields.typeLabel,
    fields.typeLabel,
  ]
    .filter(Boolean)
    .map((value) => String(value).toLowerCase());

  return parts.some((value) => value.includes(q));
}
